import { UserListItem } from '@repo/types';
import { $api } from './base';

export const getUserList = (query: string): Promise<UserListItem[]> => {
  return $api
    .get(`api/core/user-list-share/?user_contains=${query}`)
    .then((response) => response.data);
};
